import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueMeta from "vue-meta";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import { faInstagramSquare } from "@fortawesome/free-brands-svg-icons";
import { faTwitterSquare } from "@fortawesome/free-brands-svg-icons";
import { faFlickr } from "@fortawesome/free-brands-svg-icons";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { faYoutubeSquare } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faVolumeUp } from "@fortawesome/free-solid-svg-icons";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import JQuery from "jquery";
import VueInstagram from "vue-instagram";
import lodash from "lodash";
import VueLodash from 'vue-lodash'
import VueAnalytics from 'vue-analytics';
import VueGtag from "vue-gtag";
import Moment from 'moment';
import Carousel3d from 'vue-carousel-3d';
import * as CryptoJS from 'crypto-js';
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
// import VueSocketIO from 'vue-socket.io'

library.add(
  faFacebookSquare,
  faInstagramSquare,
  faTwitterSquare,
  faFlickr,
  faYoutubeSquare,
  faSearch,
  faUser,
  faPlayCircle,
  faChevronLeft,
  faChevronRight,
  faSortDown,
  faVolumeUp,
  faArrowDown,
  faArrowUp,
);
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: 'https://ocs-mena.com',
//   options: { 
//     path: '/tms/alt/socket.io',
//     transports: ['websocket', 'polling'],
//   } //Optional options
// }))
Vue.use(VueperSlides, VueperSlide);
Vue.use(Carousel3d);
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueInstagram);
Vue.use(VueAnalytics, {
  id: '',
  router
});
Vue.use(VueGtag, {
  config: { id: "" },
  includes: [
    { id: '' }
  ]
}, router);

new Vue({
  Moment,
  router,
  store,
  axios,
  JQuery,
  lodash,
  CryptoJS,
  render: h => h(App)
}).$mount("#app");
